import React, { Component } from 'react';
import { Button, Col, Input, Modal, Row } from 'antd';
import { fetchData } from '../../../lib/apis';
import ProviderConfigCard from './components/ProviderConfigCard';

const DEFAULT_CONFIG = {
    enabled: false,
    api_base_url: '',
    token: '',
    webhook_secret: '',
    test_status: 'unconfigured',
    test_message: '',
    tested_at: 0,
    usable: false,
    status: 'unconfigured',
    reason: 'Thiếu endpoint hoặc token'
};

export default class LogisticsIntegrationView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            savingProvider: '',
            testingProvider: '',
            viettelSetupVisible: false,
            viettelSeedTokenDraft: '',
            addressProvinces: [],
            addressWards: [],
            config: {
                viettel_post: {
                    ...DEFAULT_CONFIG,
                    seed_token: '',
                    access_token: '',
                    viettel_user_id: 0,
                    viettel_partner_id: 0,
                    viettel_phone: '',
                    token_expired_at: 0,
                    token_source: 0,
                    token_info_updated: false,
                    partner_id: '',
                    sender_address: {}
                },
                ghn: { ...DEFAULT_CONFIG, shop_id: '' }
            }
        };
    }

    componentDidMount() {
        this.loadConfig();
        this.loadAddressProvinces();
    }

    loadAddressProvinces = async () => {
        try {
            const res = await fetchData({ url: 'api/v1/addresses/provinces' });
            this.setState({ addressProvinces: Array.isArray(res.data) ? res.data : [] });
        } catch (err) {
            this.setState({ addressProvinces: [] });
        }
    }

    loadAddressWards = async (provinceId) => {
        if (!provinceId) {
            this.setState({ addressWards: [] });
            return;
        }
        try {
            const res = await fetchData({ url: `api/v1/addresses/wards?province_id=${encodeURIComponent(provinceId)}` });
            this.setState({ addressWards: Array.isArray(res.data) ? res.data : [] });
        } catch (err) {
            this.setState({ addressWards: [] });
        }
    }

    loadConfig = async () => {
        try {
            this.setState({ loading: true });
            const res = await fetchData({ url: 'api/v1/logistics-integrations/config' });
            const nextConfig = res.data || this.state.config;
            this.setState({ loading: false, config: nextConfig });
            const provinceId = nextConfig.viettel_post && nextConfig.viettel_post.sender_address && nextConfig.viettel_post.sender_address.province
                ? nextConfig.viettel_post.sender_address.province.id
                : '';
            if (provinceId) await this.loadAddressWards(provinceId);
        } catch (err) {
            this.setState({ loading: false });
            this.props.notification({ title: 'Logistics', content: err.message || 'Không tải được cấu hình logistics', type: 'error' });
        }
    }

    handleFieldChange = (provider, field, value) => {
        this.setState((prevState) => ({
            config: {
                ...prevState.config,
                [provider]: {
                    ...prevState.config[provider],
                    [field]: value
                }
            }
        }));
    }

    handleSenderAddressChange = (field, value) => {
        this.setState((prevState) => {
            const viettel = prevState.config.viettel_post || {};
            const sender = viettel.sender_address || {};
            let nextSender = { ...sender, [field]: value };
            if (field === 'ward_id') {
                const ward = prevState.addressWards.find((item) => `${item.id}` === `${value}`) || {};
                nextSender = {
                    ...sender,
                    ward: {
                        id: value,
                        code: ward.code || '',
                        name: ward.name || '',
                        provider_ids: ward.provider_ids || { viettel_post: value }
                    }
                };
            }
            return {
                config: {
                    ...prevState.config,
                    viettel_post: { ...viettel, sender_address: nextSender }
                }
            };
        });
    }

    handleSenderProvinceChange = async (value) => {
        const province = this.state.addressProvinces.find((item) => `${item.id}` === `${value}`) || {};
        this.setState((prevState) => ({
            config: {
                ...prevState.config,
                viettel_post: {
                    ...prevState.config.viettel_post,
                    sender_address: {
                        ...(prevState.config.viettel_post.sender_address || {}),
                        province: {
                            id: value,
                            code: province.code || '',
                            name: province.name || '',
                            provider_ids: province.provider_ids || { viettel_post: value }
                        },
                        ward: {}
                    }
                }
            },
            addressWards: []
        }));
        await this.loadAddressWards(value);
    }

    saveProvider = async (provider) => {
        try {
            if (provider === 'viettel_post') {
                const sender = (this.state.config.viettel_post && this.state.config.viettel_post.sender_address) || {};
                if (!sender.name || !sender.phone || !sender.address_line || !sender.province || !sender.province.id || !sender.ward || !sender.ward.id) {
                    throw new Error('Vui lòng nhập đủ địa chỉ lấy hàng: tên, số điện thoại, địa chỉ chi tiết, Tỉnh/Thành phố và Phường/Xã');
                }
            }
            this.setState({ savingProvider: provider });
            await fetchData({
                url: `api/v1/logistics-integrations/config/${provider}`,
                method: 'put',
                data: this.state.config[provider]
            });
            this.setState({ savingProvider: '' });
            await this.loadConfig();
        } catch (err) {
            this.setState({ savingProvider: '' });
            this.props.notification({ title: 'Logistics', content: err.message || 'Lưu cấu hình thất bại', type: 'error' });
        }
    }

    testProvider = async (provider) => {
        try {
            this.setState({ testingProvider: provider });
            await fetchData({
                url: `api/v1/logistics-integrations/test/${provider}`,
                method: 'post'
            });
            this.setState({ testingProvider: '' });
            await this.loadConfig();
        } catch (err) {
            this.setState({ testingProvider: '' });
            this.props.notification({ title: 'Logistics', content: err.message || 'Test connection thất bại', type: 'error' });
        }
    }

    openViettelSetup = () => {
        this.setState({
            viettelSetupVisible: true,
            viettelSeedTokenDraft: this.state.config.viettel_post ? this.state.config.viettel_post.seed_token || '' : ''
        });
    }

    closeViettelSetup = () => {
        this.setState({
            viettelSetupVisible: false,
            viettelSeedTokenDraft: ''
        });
    }

    saveViettelSetup = async () => {
        try {
            this.setState({ savingProvider: 'viettel_post' });
            await fetchData({
                url: 'api/v1/logistics-integrations/config/viettel_post',
                method: 'put',
                data: {
                    ...this.state.config.viettel_post,
                    enabled: true,
                    seed_token: this.state.viettelSeedTokenDraft
                }
            });
            await fetchData({
                url: 'api/v1/logistics-integrations/test/viettel_post',
                method: 'post'
            });
            this.setState({ savingProvider: '' });
            this.closeViettelSetup();
            await this.loadConfig();
        } catch (err) {
            this.setState({ savingProvider: '' });
            this.props.notification({ title: 'Logistics', content: err.message || 'Lưu cấu hình Viettel thất bại', type: 'error' });
        }
    }

    disconnectProvider = async (provider) => {
        try {
            this.setState({ savingProvider: provider });
            const current = this.state.config[provider] || {};
            const cleared = provider === 'viettel_post'
                ? {
                    ...current,
                    enabled: false,
                    seed_token: '',
                    access_token: '',
                    viettel_user_id: 0,
                    viettel_partner_id: 0,
                    viettel_phone: '',
                    token_expired_at: 0,
                    token_source: 0,
                    token_info_updated: false,
                    webhook_secret: '',
                    test_status: 'unconfigured',
                    test_message: '',
                    tested_at: 0,
                    usable: false,
                    status: 'unconfigured',
                    reason: 'Thiếu seed token'
                }
                : {
                    ...current,
                    enabled: false,
                    token: '',
                    webhook_secret: '',
                    test_status: 'unconfigured',
                    test_message: '',
                    tested_at: 0,
                    usable: false,
                    status: 'unconfigured',
                    reason: 'Thiếu endpoint hoặc token'
                };
            await fetchData({
                url: `api/v1/logistics-integrations/config/${provider}`,
                method: 'put',
                data: cleared
            });
            this.setState({ savingProvider: '' });
            await this.loadConfig();
        } catch (err) {
            this.setState({ savingProvider: '' });
            this.props.notification({ title: 'Logistics', content: err.message || 'Gỡ kết nối thất bại', type: 'error' });
        }
    }

    isViettelConfigured = () => {
        const config = this.state.config.viettel_post || {};
        return !!config.seed_token;
    }

    render() {
        const { config, savingProvider, testingProvider, viettelSetupVisible, viettelSeedTokenDraft, addressProvinces, addressWards } = this.state;
        return (
            <div className="content-m list-h">
                <div className="list-c list-m">
                    <Row gutter={16}>
                        <Col span={12}>
                            {this.isViettelConfigured() ? (
                                <ProviderConfigCard
                                    title="Viettel Post"
                                    providerKey="viettel_post"
                                    config={config.viettel_post}
                                    onChange={this.handleFieldChange}
                                    onSave={this.saveProvider}
                                    onTest={this.testProvider}
                                    onDisconnect={this.disconnectProvider}
                                    saving={savingProvider === 'viettel_post'}
                                    testing={testingProvider === 'viettel_post'}
                                    provinces={addressProvinces}
                                    wards={addressWards}
                                    onSenderAddressChange={this.handleSenderAddressChange}
                                    onSenderProvinceChange={this.handleSenderProvinceChange}
                                />
                            ) : (
                                <div className="card p-4">
                                    <h4>Viettel Post</h4>
                                    <p>Chưa cấu hình Viettel Post.</p>
                                    <Button type="primary" onClick={this.openViettelSetup}>Tích hợp Viettel Post</Button>
                                </div>
                            )}
                        </Col>
                        <Col span={12}>
                            <ProviderConfigCard
                                title="GHN"
                                providerKey="ghn"
                                config={config.ghn}
                                onChange={this.handleFieldChange}
                                onSave={this.saveProvider}
                                onTest={this.testProvider}
                                onDisconnect={this.disconnectProvider}
                                saving={savingProvider === 'ghn'}
                                testing={testingProvider === 'ghn'}
                            />
                        </Col>
                    </Row>
                </div>
                <Modal
                    title="Tích hợp Viettel Post"
                    visible={viettelSetupVisible}
                    onCancel={this.closeViettelSetup}
                    onOk={this.saveViettelSetup}
                    confirmLoading={savingProvider === 'viettel_post'}
                >
                    <div style={{ marginBottom: 8 }}>Nhập token trang cá nhân Viettel Post.</div>
                    <Input.Password value={viettelSeedTokenDraft} onChange={(e) => this.setState({ viettelSeedTokenDraft: e.target.value })} />
                </Modal>
            </div>
        );
    }
}
